import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LINKS = {
  androidInstall: "https://drive.google.com/file/d/1fUMWzaRDDh_5OmfQXeaYQIwr-3tKsdK8/view?usp=sharing",
  iosInstall: "https://drive.google.com/file/d/1yzxvEKJNvQ6qpMfEffoLKlRCaQ7EwnVs/view?usp=drive_link",
  iosChromeInstall: "https://drive.google.com/file/d/11EqaAJz5bhIV_zHW48lVM73X3RTBlhI-/view?usp=drive_link",
  afterInstallNotif: "https://drive.google.com/file/d/1beCMmAT4xMTldN5iT1c-BR3BeP97cHFs/view?usp=drive_link",
};

export default function Tutorial() {
  const navigate = useNavigate();

  useEffect(() => {
    // niente redirect se già visto (in caso l’utente ci torni manualmente)
  }, []);

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("Link copiato negli appunti ✅");
    } catch {
      alert("Copia non riuscita, tieni premuto sul link per copiarlo.");
    }
  };

  const done = () => {
    try { localStorage.setItem("rb_tutorial_done", "1"); } catch {}
    try { sessionStorage.setItem("rb_tutorial_done", "1"); } catch {}

    // ✅ IMPORTANTISSIMO su PWA: replace evita back-stack strani e “ripartenze”
    navigate("/setup", { replace: true });
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4">Benvenuto! 🎉</h1>
      <p className="text-lg sm:text-xl text-gray-700 mb-6">
        Prima di iniziare il setup, ti mostro in 2 minuti come <b>installare l’app</b> e <b>attivare le notifiche</b>.
      </p>

      {/* STEP 1: Installazione app (Android) */}
      <div className="mb-6 p-4 sm:p-6 rounded-2xl border shadow-sm">
        <h2 className="text-xl sm:text-2xl font-semibold mb-2">Step 1 — Installare l’app (Android)</h2>
        <p className="text-base sm:text-lg text-gray-700 mb-3">
          Apri il sito nell’app del browser, tocca i <b>tre puntini</b> in alto, poi <b>Aggiungi a schermata Home</b> e <b>Installa</b>.
        </p>
        <a
          className="inline-block text-base sm:text-lg text-blue-600 underline mr-3"
          href={LINKS.androidInstall}
          target="_blank"
          rel="noreferrer"
        >
          Guarda il video tutorial (Android)
        </a>
        <button
          onClick={() => copy(LINKS.androidInstall)}
          className="inline-block mt-2 sm:mt-0 text-sm px-3 py-1 border rounded"
        >
          Copia link
        </button>
      </div>

      {/* STEP 1: Installazione app (iPhone Safari) */}
      <div className="mb-6 p-4 sm:p-6 rounded-2xl border shadow-sm">
        <h2 className="text-xl sm:text-2xl font-semibold mb-2">Step 1 — Installare l’app iPhone (Safari)</h2>
        <p className="text-base sm:text-lg text-gray-700 mb-3">
          Tocca i <b>tre puntini</b> a destra della barra (o il tasto <b>Condividi</b>), poi <b>Aggiungi alla schermata principale</b>.
        </p>
        <a
          className="inline-block text-base sm:text-lg text-blue-600 underline mr-3"
          href={LINKS.iosInstall}
          target="_blank"
          rel="noreferrer"
        >
          Guarda il video tutorial (iPhone)
        </a>
        <button
          onClick={() => copy(LINKS.iosInstall)}
          className="inline-block mt-2 sm:mt-0 text-sm px-3 py-1 border rounded"
        >
          Copia link
        </button>
      </div>

      {/* STEP 1: Installazione app (iPhone Chrome) */}
      <div className="mb-6 p-4 sm:p-6 rounded-2xl border shadow-sm">
        <h2 className="text-xl sm:text-2xl font-semibold mb-2">Step 1 — Installare l’app iPhone (Chrome)</h2>
        <p className="text-base sm:text-lg text-gray-700 mb-3">
          Tocca il tasto <b>Condividi</b> (quel quadratino con la freccetta in alto che sta in basso a destra),
          poi <b>Add to Home Screen</b>.
          <br />
          Scrivi il nome <b>RespirareBene</b>, lascia verde il rettangolino <b>Open as web app</b>,
          poi premi <b>Add</b> in blu in alto a destra.
        </p>
        <a
          className="inline-block text-base sm:text-lg text-blue-600 underline mr-3"
          href={LINKS.iosChromeInstall}
          target="_blank"
          rel="noreferrer"
        >
          Guarda il video tutorial (iPhone Chrome)
        </a>
        <button
          onClick={() => copy(LINKS.iosChromeInstall)}
          className="inline-block mt-2 sm:mt-0 text-sm px-3 py-1 border rounded"
        >
          Copia link
        </button>
      </div>

      {/* STEP 2: Notifiche */}
      <div className="mb-6 p-4 sm:p-6 rounded-2xl border shadow-sm">
        <h2 className="text-xl sm:text-2xl font-semibold mb-2">Step 2 — Attivare le notifiche</h2>
        <p className="text-base sm:text-lg text-gray-700 mb-3">
          Apri l’app installata, vai su <b>Notifiche</b> → <b>Attiva notifiche</b> → invia una <b>notifica di prova</b>.
          Poi apri il menu (tre linee in alto a sinistra) → <b>Impostazioni</b> → scegli gli orari di promemoria e premi <b>Salva</b>.
          <br />
          <b>Importante:</b> se non salvi le impostazioni, le notifiche non resteranno attive anche se la prova è arrivata.
        </p>
        <a
          className="inline-block text-base sm:text-lg text-blue-600 underline mr-3"
          href={LINKS.afterInstallNotif}
          target="_blank"
          rel="noreferrer"
        >
          Video guida notifiche
        </a>
        <button
          onClick={() => copy(LINKS.afterInstallNotif)}
          className="inline-block mt-2 sm:mt-0 text-sm px-3 py-1 border rounded"
        >
          Copia link
        </button>
      </div>

      <button
        onClick={done}
        className="w-full sm:w-auto px-6 py-3 rounded-2xl bg-black text-white text-lg sm:text-xl font-semibold"
      >
        Ho capito, continua
      </button>
    </div>
  );
}
